import {
   fetchTipStart,
   fetchTipCompleted,
   fetchTipFailed,

   checkTipLimitStart,
   checkTipLimitCompleted,
   checkTipLimitFailed,
} from "./actions";
import { initTip, checkTipLimit } from 'sites/api/AuthApi';
import { setSendModalState } from 'sites/state/modules/purchase-send/actions.js';


export const initTipOperation = (params) => {
   return async (dispatch) => {
      dispatch(fetchTipStart());
      try {
         const { data }  = await initTip(params);
         dispatch(setSendModalState({ modalKey: 'tip' }));
         dispatch(fetchTipCompleted(data))
      } catch (error) {
         dispatch(fetchTipFailed())
      }
   };
};

export const checkTipLimitOperation = (modalKey = 'tip') => {
   return async (dispatch) => {
      dispatch(checkTipLimitStart());
      try {
         const data  = await checkTipLimit();
         dispatch(checkTipLimitCompleted(data));
      } catch (error) {
         if(error && error.response) {
            dispatch(checkTipLimitFailed(error.response))
         }
      }
   };
};
